module.exports = __webpack_public_path__ + "static/react-85513166531dfe39ed09b6a1be3a3c84.jpg";